export const TABLE_RECADOS = 'TABLE_RECADOS'
export const TABLE_RECADOS_PENDING = 'TABLE_RECADOS_PENDING'
export const TABLE_RECADOS_SUCCESS = 'TABLE_RECADOS_SUCCESS'
export const TABLE_RECADOS_FAILURE = 'TABLE_RECADOS_FAILURE'

export const FIND_RECADO = 'FIND_RECADO'
export const FIND_RECADO_PENDING = 'FIND_RECADO_PENDING'
export const FIND_RECADO_SUCCESS = 'FIND_RECADO_SUCCESS'
export const FIND_RECADO_FAILURE = 'FIND_RECADO_FAILURE'